import React, { useState } from "react";
import ModalShell from "../modal/ModalShell";

interface CreatePartnerModalProps {
  busy: boolean;
  onCreate: (name: string, email: string, notes: string) => void;
  onClose: () => void;
}

/**
 * Creates a referral partner. The backend assigns the code and the tokenized
 * terms-acceptance link; the admin then sends that link to the partner.
 */
const CreatePartnerModal: React.FC<CreatePartnerModalProps> = ({ busy, onCreate, onClose }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [notes, setNotes] = useState("");

  const canCreate = name.trim().length > 0 && email.includes("@") && !busy;

  return (
    <ModalShell onClose={onClose} labelledBy="create-partner-title">
      <div className="p-6">
        <h2 id="create-partner-title" className="text-lg font-bold text-grey-20 dark:text-white">
          New referral partner
        </h2>
        <p className="mt-1 text-sm text-grey-50 dark:text-grey-70">
          The partner gets a referral code and a terms-acceptance link. Their code only starts
          attributing once they accept the terms.
        </p>

        <label className="mt-4 block text-sm font-medium text-grey-30 dark:text-grey-70">
          Name
          <input
            className="input mt-1"
            value={name}
            onChange={(event) => setName(event.target.value)}
            placeholder="Anna Ampel / Musikschule Beispiel"
          />
        </label>

        <label className="mt-4 block text-sm font-medium text-grey-30 dark:text-grey-70">
          Email
          <input
            className="input mt-1"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            placeholder="partner@example.com"
          />
        </label>

        <label className="mt-4 block text-sm font-medium text-grey-30 dark:text-grey-70">
          Notes (internal)
          <textarea
            className="input mt-1"
            rows={2}
            value={notes}
            onChange={(event) => setNotes(event.target.value)}
          />
        </label>

        <div className="mt-6 flex justify-end gap-2">
          <button type="button" className="btn btn-secondary" disabled={busy} onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            disabled={!canCreate}
            onClick={() => onCreate(name.trim(), email.trim(), notes.trim())}
          >
            Create partner
          </button>
        </div>
      </div>
    </ModalShell>
  );
};

export default CreatePartnerModal;
